import { supabase } from './supabase';

export interface AssetDayAvailability {
  enabled: boolean;
  shifts: Array<{ start: string; end: string }>;
  areas?: string[];
  radius?: number;
}

export interface AssetWorkingAvailability {
  id: string;
  asset_id: string;
  business_id: string;
  monday: AssetDayAvailability;
  tuesday: AssetDayAvailability;
  wednesday: AssetDayAvailability;
  thursday: AssetDayAvailability;
  friday: AssetDayAvailability;
  saturday: AssetDayAvailability;
  sunday: AssetDayAvailability;
  created_at: string;
  updated_at: string;
}

export async function getAssetAvailability(assetId: string): Promise<AssetWorkingAvailability | null> {
  if (!supabase) throw new Error('Supabase client is not initialized');

  const { data, error } = await supabase
    .from('asset_availability')
    .select('*')
    .eq('asset_id', assetId)
    .maybeSingle();

  if (error && !error.message.includes('contains 0 rows')) throw error;
  return data;
}

export async function updateAssetAvailability(
  assetId: string,
  availability: Partial<AssetWorkingAvailability>
): Promise<void> {
  if (!supabase) throw new Error('Supabase client is not initialized');

  const { error } = await supabase
    .from('asset_availability')
    .update(availability)
    .eq('asset_id', assetId);

  if (error) throw error;
}

export async function createAssetAvailability(
  assetId: string,
  businessId: string,
  availability: Partial<AssetWorkingAvailability>
): Promise<void> {
  if (!supabase) throw new Error('Supabase client is not initialized');

  const { data: existing } = await supabase
    .from('asset_availability')
    .select('id')
    .eq('asset_id', assetId)
    .maybeSingle();

  if (existing) {
    const { error } = await supabase
      .from('asset_availability')
      .update({ business_id: businessId, ...availability })
      .eq('asset_id', assetId);
    if (error) throw error;
  } else {
    const { error } = await supabase
      .from('asset_availability')
      .insert([{ asset_id: assetId, business_id: businessId, ...availability }]);
    if (error) throw error;
  }
}

export async function getBusinessAssetsAvailability(businessId: string): Promise<AssetWorkingAvailability[]> {
  if (!supabase) throw new Error('Supabase client is not initialized');

  const { data, error } = await supabase
    .from('asset_availability')
    .select('*')
    .eq('business_id', businessId);

  if (error) throw error;
  return data || [];
}
